import React, { Fragment, useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import TawkilRequests from "./TawkilRequest";
import Checklist from "./CheckList";
import AllTawkils from "./AllTawkils";
import LegalPapers from "./legalPapers";
import image2 from "../images/logo.png";
import Cookies from 'js-cookie';

import {
  Bars3Icon,
  FolderIcon,
  PuzzlePieceIcon,
  PhoneArrowUpRightIcon,
  XMarkIcon,
  UsersIcon,
  CurrencyDollarIcon,
  ListBulletIcon,
  ScaleIcon,
  ClipboardDocumentCheckIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";
import NotaireList from "./Notairs";
import QuizList from "./QuizList";
import UserProfile from "./UserProfile";
import UserManagent from "./UserManagent";
import BudgetTracker from "./BudgetTracker";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Profile() {
  const { tab } = useParams(); // Get the 'tab' parameter from the URL
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [current, setCurrent] = useState(tab || "profile"); // Set initial state based on URL parameter
  const [navigation, setNavigation] = useState([]);
  const userc = JSON.parse(Cookies.get("user"));

  const adminNavigation = [
    { name: "Profile", href: "profile", icon: UserCircleIcon, current: false },
    { name: "Quizes", href: "quizes", icon: PuzzlePieceIcon, current: false },
    { name: "Legal Papers", href: "legal-papers", icon: ScaleIcon, current: false },
    { name: "Tawkil Service", href: "tawkil-service", icon: ClipboardDocumentCheckIcon, current: false },
    { name: "Contact Notaire", href: "contact-notaire", icon: PhoneArrowUpRightIcon, current: false },
    { name: "Users", href: "users", icon: UsersIcon, current: false },
    { name: "All Tawkils", href: "all-tawkils", icon: FolderIcon, current: false },
    { name: "ToDo List", href: "todo-list", icon: ListBulletIcon, current: false },
    { name: "Budget Tracker", href: "budget-tracker", icon: CurrencyDollarIcon, current: false },
  ];

  const userNavigation = [
    { name: "Profile", href: "profile", icon: UserCircleIcon, current: false },
    { name: "Quizes", href: "quizes", icon: PuzzlePieceIcon, current: false },
    { name: "Legal Papers", href: "legal-papers", icon: ScaleIcon, current: false },
    { name: "Tawkil Service", href: "tawkil-service", icon: ClipboardDocumentCheckIcon, current: false },
    { name: "Contact Notaire", href: "contact-notaire", icon: PhoneArrowUpRightIcon, current: false },
    { name: "Budget Tracker", href: "budget-tracker", icon: CurrencyDollarIcon, current: false },
    { name: "ToDo List", href: "todo-list", icon: ListBulletIcon, current: false },
  ];

  useEffect(() => {
    if (userc.role === "admin") {
      setNavigation(adminNavigation);
    } else {
      setNavigation(userNavigation);
    }
  }, [userc.role]);

  const toggleSelectedItems = (name) => {
    setCurrent(name);
    setSidebarOpen(false); // Close sidebar after selecting an item
  };

  return (
    <>
      <div>
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50 lg:hidden"
            onClose={setSidebarOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-900/80" />
            </Transition.Child>

            <div className="fixed inset-0 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                      <button
                        type="button"
                        className="-m-2.5 p-2.5"
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon
                          className="h-6 w-6 text-white"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
                    <div className="flex h-16 shrink-0 items-center">
                      <Link to="/" className="h-32 w-32 pt-4">
                        <img src={image2} alt="Your Company" />
                      </Link>
                    </div>
                    <nav className="flex flex-1 flex-col">
                      <ul role="list" className="flex flex-1 flex-col gap-y-7">
                        <li>
                          <ul role="list" className="-mx-2 space-y-1">
                            {navigation.map((item) => (
                              <li key={item.name}>
                                <Link
                                  to={`/dashboard/${item.href}`}
                                  className={classNames(
                                    current === item.href
                                      ? "bg-gray-50 text-pink-600"
                                      : "text-gray-700 hover:text-pink-600 hover:bg-gray-50",
                                    "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                                  )}
                                  onClick={() => toggleSelectedItems(item.href)}
                                >
                                  <item.icon
                                    className={classNames(
                                      current === item.href
                                        ? "text-pink-600"
                                        : "text-gray-400 group-hover:text-pink-600",
                                      "h-6 w-6 shrink-0"
                                    )}
                                    aria-hidden="true"
                                  />
                                  {item.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>

        <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
          <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6">
            <div className="flex h-16 shrink-0 items-center">
              <Link to="/" className="h-32 w-32 pt-4">
                <img src={image2} alt="Your Company" />
              </Link>
            </div>
            <nav className="flex flex-1 flex-col">
              <ul role="list" className="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul role="list" className="-mx-2 space-y-1">
                    {navigation.map((item) => (
                      <li key={item.name}>
                        <Link
                          to={`/dashboard/${item.href}`}
                          className={classNames(
                            current === item.href
                              ? "bg-gray-50 text-pink-600"
                              : "text-gray-700 hover:text-pink-600 hover:bg-gray-50",
                            "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                          )}
                          onClick={() => toggleSelectedItems(item.href)}
                        >
                          <item.icon
                            className={classNames(
                              current === item.href
                                ? "text-pink-600"
                                : "text-gray-400 group-hover:text-pink-600",
                              "h-6 w-6 shrink-0"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="sticky top-0 z-40 flex items-center gap-x-6 bg-white px-4 py-4 shadow-sm sm:px-6 lg:hidden">
          <button
            type="button"
            className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
          <div className="flex-1 text-sm font-semibold leading-6 text-gray-900">
            Dashboard
          </div>
        </div>

        <main className="py-10 lg:pl-72">
          <div className="px-4 sm:px-6 lg:px-8">
            {userc.role === "admin" ? (
              <>
                <div>{current === "profile" && <UserProfile />}</div>
                <div>{current === "quizes" && <QuizList />}</div>
                <div>{current === "legal-papers" && <LegalPapers />}</div>
                <div>{current === "tawkil-service" && <TawkilRequests />}</div>
                <div>{current === "contact-notaire" && <NotaireList />}</div>
                <div>{current === "users" && <UserManagent />}</div>
                <div>{current === "all-tawkils" && <AllTawkils />}</div>
                <div>{current === "todo-list" && <Checklist />}</div>
                <div>{current === "budget-tracker" && <BudgetTracker />}</div>
              </>
            ) : (
              <>
                <div>{current === "profile" && <UserProfile />}</div>
                <div>{current === "quizes" && <QuizList />}</div>
                <div>{current === "legal-papers" && <LegalPapers />}</div>
                <div>{current === "tawkil-service" && <TawkilRequests />}</div>
                <div>{current === "contact-notaire" && <NotaireList />}</div>
                <div>{current === "budget-tracker" && <BudgetTracker />}</div>
                <div>{current === "todo-list" && <Checklist />}</div>
              </>
            )}
          </div>
        </main>
      </div>
    </>
  );
}
